import { Stack, Typography, TextField, Button } from "@mui/material"
import { useState } from "react";
import { useForm } from "../../../hooks/useForm";
import { Message } from "../../../components/Message";
import { messagesForgot } from "../../../helpers/userMessage";

export const PasswordRecovery = ({ forgot, setForgot }) => {

  const [formValues, handleInputChange, reset] = useForm({
    email: ''
  })
  
  const [isSend, setIsSend] = useState(false);
  const [body, setBody] = useState({});

  const { email } = formValues;

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSend(!isSend);
    setBody({
      email: email
    })
  }

const handleCancel = () => {
  setForgot(!forgot)
};

return (
  <Stack component='form' justifyContent='center' alignItems='center' className="login_container" onSubmit={handleSubmit} >
    <Stack gap={1} alignItems='center' width='90%' >
      <Typography textAlign='center' variant="h5" color="primary">Recuperar contraseña</Typography>
      <Typography textAlign='center' variant="body2" >¿No recuerda su contraseña? Le enviaremos una nueva a su email</Typography>
      <TextField
        label="Email"
        type="search"
        variant="standard"
        name="email"
        value={email}
        onChange={handleInputChange}
        sx={{ width: '80%', pb: '2rem', mt: '1rem' }}
      />
      <Button variant="contained" size='small' sx={{ width: '70%' }} type='submit'>Enviar</Button>
      <Button variant="text" size='small' sx={{ width: '70%' }} onClick={handleCancel}>Cancelar</Button>
    </Stack>
    {isSend && <Message reset={reset} setIsCreate={setIsSend} messages={messagesForgot} method='PUT' body={body}  />}

  </Stack>
)
}
